import { Component } from '@angular/core';

@Component({
  selector: 'demo-colors',
  templateUrl: './colors.component.html',
  styleUrls: ['./colors.component.scss'],
  standalone: false,
})
export class DemoColorsComponent {}
